import { Home } from 'lucide-react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'

/**
 * ReturnHomeButton Component
 *
 * Reusable button/link to return to the landing page
 * Used in minimal layouts for AI Dashboard and Narrative Dashboard
 */
function ReturnHomeButton({ variant = 'button', className = '' }) {
  const baseClasses =
    'inline-flex items-center gap-2 px-4 py-2 rounded-lg font-medium transition-colors'

  const variantClasses = {
    button: 'bg-gray-100 text-gray-700 hover:bg-gray-200 hover:text-gray-900',
    link: 'text-gray-600 hover:text-gray-900',
    primary: 'bg-primary-100 text-primary-700 hover:bg-primary-200',
  }

  return (
    <Link
      to="/"
      className={`${baseClasses} ${variantClasses[variant]} ${className}`}
    >
      <Home className="w-4 h-4" />
      <span>Home</span>
    </Link>
  )
}

ReturnHomeButton.propTypes = {
  variant: PropTypes.oneOf(['button', 'link', 'primary']),
  className: PropTypes.string,
}

export default ReturnHomeButton
